import React from 'react';
import { FaSpinner, FaChartLine, FaBrain, FaHistory, FaImage } from 'react-icons/fa';

const QuickActionsGrid = ({
    onAnalyzeBusiness,
    onGenerateIdea,
    onNavigateToAnalytics,
    onNavigateToMarketingHistory,
    onNavigateToSocialContent,
    analyzingBusiness,
    generatingIdea,
    ideaGenerationCooldown,
    cooldownTimeRemaining
}) => {
    return (
        <div className="bg-white rounded-lg shadow-sm p-3 sm:p-4 md:p-5 lg:p-6 h-full flex flex-col">
            <div className="mb-3 sm:mb-4">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900">Acciones Rápidas</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3 sm:gap-4 flex-1">
                {/* Analizar Negocio */}
                <button
                    onClick={onAnalyzeBusiness}
                    disabled={analyzingBusiness}
                    className="p-3 sm:p-4 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-lg shadow hover:from-blue-600 hover:to-blue-700 transition-all disabled:opacity-50 text-sm sm:text-base"
                >
                    <div className="flex items-center justify-center space-x-2">
                        {analyzingBusiness ? (
                            <FaSpinner className="animate-spin text-lg sm:text-xl" />
                        ) : (
                            <FaBrain className="text-lg sm:text-xl" />
                        )}
                        <span className="whitespace-nowrap">Analizar Negocio</span>
                    </div>
                </button>

                {/* TODO: Generar Posts - COMENTADO HASTA VERIFICAR IMPLEMENTACIÓN */}
                {/* 
                <button
                    onClick={onNavigateToSocialContent}
                    className="p-4 bg-gradient-to-br from-purple-500 to-purple-600 text-white rounded-lg shadow hover:from-purple-600 hover:to-purple-700 transition-all"
                >
                    <div className="flex items-center justify-center space-x-2">
                        <FaImage className="text-xl" />
                        <span>Generar Posts</span>
                    </div>
                </button>
                */}

                {/* Ver Análisis */}
                <button
                    onClick={onNavigateToAnalytics}
                    className="p-3 sm:p-4 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-lg shadow hover:from-green-600 hover:to-green-700 transition-all text-sm sm:text-base"
                >
                    <div className="flex items-center justify-center space-x-2">
                        <FaChartLine className="text-lg sm:text-xl" />
                        <span className="whitespace-nowrap">Ver Análisis</span>
                    </div>
                </button>

                {/* Historial de Marketing */}
                <button
                    onClick={onNavigateToMarketingHistory}
                    className="p-3 sm:p-4 bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-lg shadow hover:from-orange-600 hover:to-orange-700 transition-all text-sm sm:text-base"
                >
                    <div className="flex items-center justify-center space-x-2">
                        <FaHistory className="text-lg sm:text-xl" />
                        <span className="whitespace-nowrap">Historial</span>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default QuickActionsGrid; 